exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".site-nav-mobile[data-v-8dfeb5e0] {\n  height: 100%;\n}\n.site-nav-mobile-header[data-v-8dfeb5e0] {\n  border-bottom: 1px solid #f7f7f8;\n}\n", ""]);

// exports
